import catalog from "../../../shared/catalog.json";
import type { Motion } from "./world";

export type PrimitiveModel =
  | "cone" | "cylinder" | "crate" | "bench" | "tree" | "lamp"
  | "car" | "van" | "kiosk" | "house" | "tower" | "block"
  | "tank" | "house_big" | "skyscraper" | "city_block"
  | "person" | "dog" | "cat" | "bird" | "bike" | "taxi" | "bus"
  | "cart" | "fountain";

interface SharedObjectDefinition {
  kind: number; id: string; name: string; tier: number; model: PrimitiveModel;
  footprint: number; height: number; mass: number; score: number; growth: number;
  color: number; accent: number; motion: Motion; speed: number;
}

export interface ObjectDefinition extends Omit<SharedObjectDefinition, "footprint" | "name"> {
  label: string;
  /** Horizontal radius; shared JSON and Go intentionally store the diameter. */
  footprint: number;
}

export const CATALOG_VERSION = catalog.version;
export const OBJECT_CATALOG: readonly ObjectDefinition[] = (catalog.kinds as SharedObjectDefinition[]).map((entry) => ({
  ...entry, label: entry.name, footprint: entry.footprint * 0.5,
}));
const BY_KIND = new Map(OBJECT_CATALOG.map((entry) => [entry.kind, entry]));
export function objectByKind(kind: number): ObjectDefinition {
  return BY_KIND.get(kind) ?? OBJECT_CATALOG[0]!;
}
const BY_ID = new Map(OBJECT_CATALOG.map((entry) => [entry.id, entry]));
export function objectById(id: string): ObjectDefinition {
  return BY_ID.get(id) ?? OBJECT_CATALOG[0]!;
}
export function canFitInHole(holeRadius: number, objectRadius: number, centerDistance = 0): boolean {
  return objectRadius <= holeRadius * catalog.eatFitMargin &&
    centerDistance + objectRadius <= holeRadius * 1.02;
}
export function stableVariant(seed: number, itemId: number, count: number): number {
  let value = (seed ^ Math.imul(itemId + 1, 0x9e3779b1)) >>> 0;
  value ^= value >>> 16; value = Math.imul(value, 0x7feb352d) >>> 0; value ^= value >>> 15;
  return count > 0 ? value % count : 0;
}

